$shm_knowledge_manual_editor $mol_page
	api_url \
	api_headers *
	kind \
	baseline? null
	load? null
	saved? null
	tools /
		<= Save $mol_button_major
			title \Сохранить
			enabled <= save_enabled false
			click? <=> save? null
		<= Cancel $mol_button_minor
			title \Отменить изменения
			enabled <= cancel_enabled true
			click? <=> cancel? null
		<= Close $mol_button_minor
			hint \Закрыть редактор
			click? <=> close? null
			sub / <= Close_icon $mol_icon_close
	body /
		<= Input $mol_textarea
			value? <=> draft? \
			hint \Текст документа Markdown
		<= Error $mol_view
			sub / <= error? \
